<template>
  <div class="groups">
    <!--INIT HIDDEN MODAL Selector -->
    <modal ref="helpModal" :title="modalTitle">
      <template #content>
        <help-group></help-group>
      </template>
    </modal>
    <!--END HIDDEN MODAL Selector -->

    <!--INIT Resume Selector -->
    <b-card class="md-3">
      <b-row>
        <b-col>
          <Locations @selectLocation="setLocation"></Locations>
        </b-col>
      </b-row>
    </b-card>
    <!-- END Resume Selector -->

    <!-- SPACER-->
    <spacer-card />
    <!-- SPACER-->

    <!--INIT Main Selector -->
    <b-card class="md-3">
      <b-row style="padding: 0px 0px 0px 10px; !important">
        <b-col cols="3"> </b-col>
        <b-col>
          <b-button
            class="buttonClass"
            variant="success"
            size="sm"
            style="margin: 0px !important"
            @click="showEditFormModal()"
            v-if="isUserAdmin()"
          >
            <i class="fas fa-plus" style="margin-right: 5px"></i>
            <span
              class="text-uppercase"
              style="font-weight: 600; font-size: 13px"
              >Registrar nueva agrupación</span
            >
          </b-button>
        </b-col>
        <b-col cols="2">
          <div>
            <img
              style="margin-right: 20px"
              class="botonAyuda"
              title="Ayuda"
              :src="getImgUrl('help.svg')"
              @click="showModalHelp()"
            />
          </div>
        </b-col>
      </b-row>
      <b-row style="padding: 0px 20px 0px 20px">
        <b-col
          cols="3"
          style="
            border: 1px solid rgba(0, 0, 0, 0.125);
            border-radius: 0.25rem;
            margin-top: 10px;
          "
        >
          <div
            style="padding: 5px; border-bottom: 1px solid rgba(0, 0, 0, 0.125)"
          >
            <b-row>
              <b-col
                class="text-center"
                style="color: #606266; font-size: 0.9rem"
                ><span style="font-weight: 700 !important">Tipología:</span>
                {{ location.type.name }}</b-col
              >
            </b-row>
          </div>
          <div style="text-align: center">
            <img
              style="width: 200px; opacity: 0.4"
              :src="getImgUrl(location.type.image)"
            />
          </div>
        </b-col>
        <b-col>
          <b-row style="margin-top: 10px">
            <!-- INIT tabla grupos -->
            <groups-table
              ref="groupTable"
              @rowedit="showEditFormModal"
              @rowview="loadGroupDetails"
            />
            <!-- END tabla grupos -->
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <!-- END Main Selector -->

    <!-- HIDDEN View MODAL-->
    <GroupsViewModal ref="groupViewModal" />
    <!-- HIDDEN View MODAL-->

    <!-- HIDDEN EDIT MODAL-->
    <groups-edit-modal ref="groupEditModal" @onClickSave="refreshList" />
    <!-- HIDDEN EDIT MODAL-->
  </div>
</template>

<script>
import Modal from "@/components/common/Modal";
import GroupsViewModal from "@/components/groups/GroupsViewModal";
import GroupsEditModal from "@/components/groups/GroupsEditModal";
import GroupsTable from "@/components/groups/GroupsTable";
import Spacer from "@/components/card/Spacer";
import UserService from "@/services/UserService";
import HelpGroup from "@/components/help/HelpGroup";
import Locations from "./components/Locations";

export default {
  data() {
    return {
      currentView: "groups-edit",
      isFormVisible: false,
      modalTitle: "",
      location: {
        type: { name: "", image: "" },
      },
    };
  },
  components: {
    "groups-table": GroupsTable,
    "groups-edit-modal": GroupsEditModal,
    "spacer-card": Spacer,
    modal: Modal,
    "help-group": HelpGroup,
    Locations,
    GroupsViewModal,
  },
  methods: {
    loadGroupDetails(id) {
      this.$refs.groupViewModal.showModal(id);
    },

    showEditFormModal(idGrupo) {
      //Enviamos la localizacion y el grupo que deseamos cargar
      this.$refs.groupEditModal.showModal(idGrupo, this.location);
    },

    refreshList() {
      this.$refs.groupTable.refreshList(this.location);
    },

    setLocation(location) {
      this.location = location;
      this.$refs.groupTable.retrieveGroup(location);
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },

    getImgUrl(image) {
      if (image && image!='') {
        return require("@/assets/images/" + image);
      }else{
        return require("@/assets/images/not-found.png");
      }
    },

    showModalHelp() {
      this.modalTitle = "Ayuda - Crear nuevo grupo";
      this.$refs.helpModal.show();
    },
  },
};
</script>

<style>
.buttonClass {
  margin: 16px;
  margin-left: 5px;
  font-size: 12px;
  font-weight: bold;
}

.botonAyuda {
  width: 30px;
  margin-right: 10px;
  padding: 2px;
  float: right;
  cursor: pointer;
}

.botonAyuda:hover {
  padding: 0px;
}
</style>
